import { LoginService } from 'projects/services/src/app/API/login/login.service';
import { ShareDataService } from 'projects/shared/src/app/shared/share-data.service';
import { HttpErrorResponse } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { RoutingService } from 'projects/services/src/app/routing.service';
import { ActivatedRoute, Router } from '@angular/router';
import { StorageService } from 'projects/services/src/app/storage.service';
import { ApiService } from 'projects/services/src/app/API/api.service';
import { Component, OnInit, OnDestroy } from '@angular/core';
import { CurrentUserService } from 'projects/services/src/app/current-user.service';
import { LoadingService } from 'projects/services/src/app/loading.service';
import { Helpers } from 'projects/training-calendar/src/app/helpers';
import { UserIdleService } from 'angular-user-idle';
import { CookieService } from 'ngx-cookie';
import { interval, Observable, Subscription } from 'rxjs';
import { RegistrationService } from 'projects/services/src/app/API/registration.service';
import { ERROR_RESPONSE_MESSAGE } from 'projects/training-partner/src/app/training-partner/constants/string.constant';
import { ValidationService } from 'projects/services/src/app/validation.service';
import { JwtHelperService } from '@auth0/angular-jwt';
import * as CryptoJS from 'crypto-js';
import { UserService } from 'projects/services/src/app/API/user.service';
import { TrainingPartnerService } from 'projects/services/src/app/API/training-partner.service';
import { DomSanitizer } from '@angular/platform-browser';

declare var toastr: any;
declare var $: any;
declare var swal: any;
@Component({
	selector: 'app-login',
	templateUrl: './login.component.html',
	styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit, OnDestroy {
	userCredentials: { userName: string, password: string } = { userName: '', password: '' };
	loginForm: FormGroup;
	otpForm: FormGroup;
	contactDetailForm: FormGroup;
	show: boolean;
	idle: any;
	idleTimer: number = 0;
	commonToken = '';
	verifyUpdateDetails = false;
	userContactDetails: any;
	isUserAuthenticated = false;
	token;
	spoc;
	isNoContinueLoginFlag = false;
	pageLoad = false;
	summaryURL: any;
	dbtURL: any;
	attendanceURL:any;
	verifyOTPForm: FormGroup;
	isModelOpened: boolean = false;
	timeRemaining: number = 30; // OTP valid time in seconds
	timerSubscription!: Subscription;

	constructor(
		private apiService: ApiService,
		private storageService: StorageService,
		private router: Router,
		private routingService: RoutingService,
		private formBuilder: FormBuilder,
		private currentUserService: CurrentUserService,
		private loadingService: LoadingService,
		private loginService: LoginService,
		private sharedService: ShareDataService,
		private jwtHelper: JwtHelperService,
		private userIdle: UserIdleService,
		private cookiService: CookieService,
		private registrationService: RegistrationService,
		private activatedRoute: ActivatedRoute,
		private userService: UserService,
		private trainingPartnerService: TrainingPartnerService,
		private domSanitizer: DomSanitizer
	) {
		this.cscCandidateLogin();
		this.loginForm = this.formBuilder.group({
			'username': ['', Validators.required],
			'password': ['', Validators.required],
			// 'recaptchaReactive': [null, Validators.required]
		});
		this.otpForm = this.formBuilder.group({
			'emailOTP': ['', [Validators.pattern('[0-9]{6}')]],
			'mobileOTP': ['', [Validators.pattern('[0-9]{6}')]]
		});
		this.contactDetailForm = this.formBuilder.group({
			'email': ['', [Validators.required, ValidationService.emailV]],
			'phone': ['', Validators.compose([Validators.required,
			Validators.pattern('^[4-9][0-9]{9}$')])],
		});
		this.verifyOTPForm = this.formBuilder.group(
			{
				'mobileOTP': ['', [Validators.required, Validators.pattern('[0-9]{6}')]]
			});
		this.show = false;
		console.log("login Page");
		/* PMV : Update summaryURL dashboard link change SIDD-77750
		this.summaryURL = this.domSanitizer.bypassSecurityTrustResourceUrl("https://app.powerbi.com/view?r=eyJrIjoiNzQ0NTQzNDAtOWQzNi00Njg1LTk5NmEtNDhkYjJmNDgyMWQ5IiwidCI6IjcyNGI4ZWQxLTgxODMtNGNiOS1iNWIwLTFlZDY3YWZlYWNmMSIsImMiOjEwfQ%3D%3D");
		*/
		this.summaryURL = this.domSanitizer.bypassSecurityTrustResourceUrl("https://app.powerbi.com/view?r=eyJrIjoiMTg3OGE0ZmYtNjliOC00ZTVlLWI5NjgtZTJhNmM0YjFkNWNkIiwidCI6IjcyNGI4ZWQxLTgxODMtNGNiOS1iNWIwLTFlZDY3YWZlYWNmMSIsImMiOjEwfQ%3D%3D");
		/* PMV : Update DBT dashboard link change SIDD-31190
		this.dbtURL = this.domSanitizer.bypassSecurityTrustResourceUrl("https://app.powerbi.com/view?r=eyJrIjoiNDY3ZTZhZWItYmMzYi00Yjc5LWI3YTctNDYxNWEyOTM1MzYyIiwidCI6IjcyNGI4ZWQxLTgxODMtNGNiOS1iNWIwLTFlZDY3YWZlYWNmMSIsImMiOjEwfQ%3D%3D")
		 */
		/* PMV : Update DBT dashboard link change https://nodes1.atlassian.net/browse/SIDH-99639
		this.dbtURL = this.domSanitizer.bypassSecurityTrustResourceUrl("https://app.powerbi.com/view?r=eyJrIjoiM2FmNDQzMTQtYWI2Zi00MTBjLTg0NzQtYmRkOWE1NTI3ZTAyIiwidCI6IjcyNGI4ZWQxLTgxODMtNGNiOS1iNWIwLTFlZDY3YWZlYWNmMSIsImMiOjEwfQ%3D%3D")
		*/
		this.dbtURL = this.domSanitizer.bypassSecurityTrustResourceUrl("https://app.powerbi.com/view?r=eyJrIjoiNGVhY2E5YjQtYzE2Zi00NGU3LWFhMzUtYzUxM2YwMjcyNjlhIiwidCI6IjcyNGI4ZWQxLTgxODMtNGNiOS1iNWIwLTFlZDY3YWZlYWNmMSIsImMiOjEwfQ%3D%3D")
		this.attendanceURL = this.domSanitizer.bypassSecurityTrustResourceUrl("https://app.powerbi.com/view?r=eyJrIjoiYzlhMTU3MGMtNTIwYS00MzUzLWFjMmItOTkzYTAyNGVmNzhkIiwidCI6IjcyNGI4ZWQxLTgxODMtNGNiOS1iNWIwLTFlZDY3YWZlYWNmMSIsImMiOjEwfQ%3D%3D")


	}

	ngOnInit() {
		// Removed checking either user is already loggedin or  not ->   16/04/2017
		// this.checkForLoggedInUser();
		this.logoutExistingUser();
		// Helpers.openModal('m_modal_1_2');
		this.idleTimer = 0;
		// this.isSidSipRedirection();
		this.isVishwakarmaRedirection();
		// this.cscCandidateLogin();
	}

	registerNow() {
		const state = Math.random().toString().substring(2, 12);
		localStorage.setItem('state', state);
		// const URL = `https://connectuat.csccloud.in/account/authorize?response_type=code&client_id=210ab52f-eacf-453e-d376-d3d878bd9c2a&redirect_uri=http://13.234.229.108/login&state=${state}`
		const URL = `https://connect.csc.gov.in/account/authorize?response_type=code&client_id=3d37e80d-5046-4da1-eae5-e394881549c2&redirect_uri=https://portals.pmvishwakarma.gov.in/login&state=${state}`
		// const URL = `https://connectuat.csccloud.in/account/authorize?response_type=code&client_id=210ab52f-eacf-453e-d376-d3d878bd9c2a&redirect_uri=https://pmv.ekaushal.com/login&state=${state}`

		window.open(URL);
	}


	bufferToBase64(buffer: ArrayBuffer): string {
		const bytes = new Uint8Array(buffer);
		let binary = '';
		bytes.forEach((b) => (binary += String.fromCharCode(b)));
		return window.btoa(binary);
	}
	isSidSipRedirection() {
		this.activatedRoute.queryParams.subscribe(params => {
			let cred = params['uc'];
			let decryptedData = CryptoJS.AES.decrypt(cred, '0n3v1ew').toString(CryptoJS.enc.Utf8);
			decryptedData = JSON.parse(decryptedData);
			if (decryptedData && decryptedData.UserName && decryptedData.Secret) {
				// call login api 
				let payload = {
					userName: decryptedData.UserName,
					secretkey: decryptedData.Secret
				}
				this.loginService.login(payload).subscribe(
					res => {
						if (res) {
							let token = res.token || res.body && res.body.token;
							if (!token) {
							} else {
								this.sharedService.setData(null)
								this.storageService.setObject('access_token', token);
								this.routingService.goNext();
								//this.initiateIdleTimer()
							}
						}
					},
					err => {
						this.loadingService.unblockuI();
						toastr.error(err.error);
					}
				);
			}

		});
	}

	isVishwakarmaRedirection() {
		this.activatedRoute.queryParams.subscribe(params => {
			let cred = params['vs'];
			let decryptedData = CryptoJS.AES.decrypt(cred, 'u+ohYIWo9N6LHLialn4vbDufJ6OFlMO0+aqNmgKpf2A=').toString(CryptoJS.enc.Utf8);
			decryptedData = JSON.parse(decryptedData);
			if (decryptedData && decryptedData.PMVCandidateId) {
				// call login api 
				let payload = {
					mobile: decryptedData.mobile,
					applicantNumber: decryptedData.PMVCandidateId,
				}
				this.userService.pmVishwakarmaCandidateLogin(payload).subscribe(res => {
					if (res.token) {
						let token = res.token || res.body && res.body.token;
						if (!token) {
						} else {
							this.sharedService.setData(null)
							this.storageService.setObject('access_token', token);
							this.routingService.goNext();
						}

					}
				})
			}
		});
	}

	cscCandidateLogin() {
		this.activatedRoute.queryParams.subscribe(params => {
			let code = params['code'];
			if (code) {
				let payload = {
					code: code,
				}
				this.trainingPartnerService.cscCandidateLogin(payload).subscribe(res => {
					if (res.token) {
						let token = res.token || res.body && res.body.token;
						if (!token) {
						} else {
							this.sharedService.setData(null)
							this.storageService.setObject('access_token', token);
							this.currentUserService.setCurrentUser(res.User);
							this.routingService.navigateToDashboard(res.User.role, "");
						}
					}
				})
			}
		});
	}


	checkForLoggedInUser() {
		if (this.storageService.getObject('access_token')) {
			this.currentUserService.getCurrentUser().subscribe((currentUser) => {
				if (currentUser != null) {
					this.routingService.goNext();
				} else {
					this.currentUserService.setCurrentUser();
					this.routingService.goNext();
				}
			});
		}
	}
	async doLogin() {
		// this.loadingService.blockUI();
		const loginUrl = environment.userServiceUrl + '/api/user/v1/login';
		const creds = Object.assign({}, this.userCredentials);
		// creds.userName = creds.userName.toUpperCase();
		const publicKey = await this.loginService.getPublicKey().toPromise();
		console.log(publicKey.publicKey);
		const encrypted = await this.loginService.encryptPassword(publicKey.publicKey, creds.password, publicKey.secret);
		creds.password = encrypted;
		creds.userName = creds.userName;
		// creds.password = btoa(creds.password);
		this.loginService.login(creds)
			.subscribe(
				res => {
					if (res) {
						this.token = res.token || res.body && res.body.token;
						this.commonToken = res.token || res.body && res.body.token;
						this.isUserAuthenticated = res.isUserAuthenticated;
						if (!this.token) {
						} else {
							if (res.isDuplicateSPOC) {
								this.storageService.setObject('access_token', this.token);
								this.sharedService.setData(this.userCredentials.userName);
								this.router.navigate(['/duplicate-spoc-change']);
								return;
							}
							if (res.hasOwnProperty('defaultPassword')) {
								this.storageService.setObject('access_token', this.token);
								this.sharedService.setData(this.userCredentials.userName);
								this.router.navigate(['/password-reset']);
							} else {
								// this.storageService.setObject('access_token', token);
								this.sharedService.setData('');
								const userDetails = this.jwtHelper.decodeToken(this.token);
								this.userContactDetails = res;
								if ((res.isUserAuthenticated === false || res.isUserAuthenticated === true) && (userDetails.role == 'NSDC Admin' || userDetails.role == 'Training Partner' ||
									userDetails.role == "NSDCAdmin" || userDetails.role == "NSDC IT ADMIN" || userDetails.role == "NSDC Super Admin" || userDetails.role == 'SSC')) {
									if (res.isUserAuthenticated == false) {
										Helpers.openModal('otpVerificationFirstTime');
										this.otpForm.controls.emailOTP.setValidators([Validators.required]);
										this.otpForm.controls.mobileOTP.setValidators([Validators.required]);
										this.otpForm.controls.emailOTP.updateValueAndValidity();
										this.otpForm.controls.mobileOTP.updateValueAndValidity();
									} else {
										this.generateOTPs();
										this.otpForm.controls.emailOTP.clearValidators();
										this.otpForm.controls.mobileOTP.clearValidators();
										this.otpForm.controls.emailOTP.updateValueAndValidity();
										this.otpForm.controls.mobileOTP.updateValueAndValidity();
										Helpers.openModal('otpVerification');
									}
								} else {
									if (res.passwordChangeRequired) {
										//set is password reset required to service and navigate to page to reset
										this.sharedService.setData('password-change');
										this.storageService.setObject('access_token', this.token);
										this.routingService.goNext();
										this.initiateIdleTimer()
										return;
									} else if (res.spocChangeRequired) {
										this.spoc = {
											phone: res.phone || '',
											email: res.email || ''
										}
										Helpers.openModal('spoc-confirmation');
										this.initiateIdleTimer();
										return;
									} else {
										this.generateOTPForLoginVerification();
										// this.sharedService.setData(null)
										// this.storageService.setObject('access_token', this.token);
										// this.routingService.goNext();
										// this.initiateIdleTimer()
									}

								}

							}
						}

					}
				},
				err => {
					this.loadingService.unblockuI();
					if (err.error instanceof HttpErrorResponse) {
						toastr.error(err.error);
					}
				}
			);

	}

	initiateIdleTimer() {
		// Start watching for user inactivity.\
		let counter = 5;
		this.userIdle.startWatching();
		// Start watching when user idle is starting and reset if user action is there.
		this.userIdle.onTimerStart().subscribe(count => {
			// counter = (count - 300)
			if (count === 1) {
				swal({
					title: `Your session will be expiring in <b>${counter} Minutes</b>, do you want to continue?`,
					type: 'warning',
					showCancelButton: true,
					cancelButtonText: 'No',
					cancelButtonColor: '#d33',
					confirmButtonText: 'Yes',
					confirmButtonColor: '#006400'
				}).then((action: any) => {
					if (action.value) {
						this.getRefreshtoken();
						this.userIdle.stopTimer();
					} else {
						this.logout()
					}
				})
			}
			const eventList = [
				'mousedown',
				'click',
				'keydown',
				'keyup'
			];
			for (let event of eventList) {
				document.body.addEventListener(event, () => this.userIdle.resetTimer());
			}
		});
		// Start watch when time is up.
		this.userIdle.onTimeout().subscribe((res) => {
			if (res) {
				swal.clickCancel();
				swal.close();
			}
		})

		interval(900000).subscribe(x => {
			const token = this.storageService.getObject('access_token');
			if (token) {
				this.currentUserService.getRefreshToken().subscribe(r => {
					console.log(r);
					if (r && r.authToken) {
						// this.cookiService.remove('_usr');
						this.storageService.setObject('access_token', token);
						localStorage.setItem('access_token', r.authToken);
						// this.cookiService.put('_usr', r.authToken);
					}
				})
			}
		});
	}

	logout() {
		const token = this.storageService.getObject('access_token');
		if (token) {
			const userDetails = this.jwtHelper.decodeToken(token);
			if (this.jwtHelper.isTokenExpired(token) === false) {
				this.storageService.removeAll();
				const cred = {
					userName: userDetails.userName
				};
				this.loginService.logout(cred, true).subscribe(res => {
				});
				this.userIdle.stopWatching();
				// this.userIdle.stopTimer();
				this.router.navigate(['/']);
				// localStorage.clear();
			} else {
				const cred = {
					userName: userDetails.userName
				};
				this.loginService.logout(cred, true).subscribe(res => {
				});
				this.storageService.removeAll();
				this.userIdle.stopWatching();
				// this.userIdle.stopTimer();
				localStorage.clear();
				// this.cookiService.remove('_usr');
				this.router.navigate(['/']);
			}
		}
	}

	getRefreshtoken() {
		const token = this.storageService.getObject('access_token');
		if (token) {
			this.currentUserService.getRefreshToken().subscribe(r => {
				console.log(r);
				if (r && r.authToken) {
					localStorage.setItem('access_token', r.authToken);
					this.storageService.setObject('access_token', token);
					// this.cookiService.remove('_usr');
					// this.cookiService.put('_usr', r.authToken);
					this.userIdle.resetTimer();
				}
			})
		}
	}


	showPassClick() {
		this.show = !this.show;

	}
	logoutExistingUser() {
		const token = this.storageService.getObject('access_token');
		if (token) {
			const userDetails = this.jwtHelper.decodeToken(token);
			if (this.jwtHelper.isTokenExpired(token) === false) {
				this.storageService.removeAll();
				const cred = {
					userName: userDetails.userName
				};
				this.loginService.logout(cred, true).subscribe(res => { });
			}
		}

	}


	generateOTPs() {
		const creds = this.userCredentials.userName;
		this.registrationService.generateOTPForForgotPassword(creds, true)
			.subscribe(
				res => {
					this.userContactDetails = res;
				}, err => {
					if (err && err.error && err.error.message) {
						toastr.error(err.error.message);
					}
				});
	}

	verifyOTP(m?) {
		let setPasswordDetails = {}
		if (m === 'everyTime') {
			setPasswordDetails = {
				phoneOtp: this.otpForm.get('emailOTP').value,
				emailOtp: this.otpForm.get('emailOTP').value,
				userID: this.userCredentials.userName,
			};
		} else {
			setPasswordDetails = {
				phoneOtp: this.otpForm.get('mobileOTP').value,
				emailOtp: this.otpForm.get('emailOTP').value,
				userID: this.userCredentials.userName,
			};
		}

		if (this.isNoContinueLoginFlag) {
			this.registrationService.verifyOTPForTPTCSpoc(setPasswordDetails, true).subscribe(res => {
				if (res) {
					swal('OTP is verified Successfully')
						.then((action: any) => {
							if (action.value) {
								this.loginService.updateSpocFlag().subscribe(res => { });
								this.storageService.setObject('access_token', this.commonToken);
								this.routingService.goNext();
								this.initiateIdleTimer();
							} else {
								this.logout()
							}
						});
					Helpers.closeModal('otpVerification');
					Helpers.closeModal('otpVerificationFirstTime');
					this.otpForm.reset();
					// this.storageService.setObject('access_token', this.commonToken);
					// this.routingService.goNext();
					// this.initiateIdleTimer();
					// this.showform = 'password';
				}
			}, err => {
				if (err && err.error && err.error.message) {
					toastr.error(atob(err.error.message));
					if (atob(err.error.message).trim() === ERROR_RESPONSE_MESSAGE.INVALID_OTP_5_TIMES) {
						// this.showform = 'generateOTP';
					}
				}
			})
		} else {
			this.registrationService.verifyOTPForRegistration(setPasswordDetails, true).subscribe(res => {
				if (res) {
					swal('OTP is verified Successfully')
						.then((action: any) => {
							if (action.value) {
								this.loginService.updateSpocFlag().subscribe(res => { });
								this.storageService.setObject('access_token', this.commonToken);
								this.routingService.goNext();
								this.initiateIdleTimer();
							} else {
								this.logout()
							}
						});
					Helpers.closeModal('otpVerification');
					Helpers.closeModal('otpVerificationFirstTime');
					this.otpForm.reset();
					// this.storageService.setObject('access_token', this.commonToken);
					// this.routingService.goNext();
					// this.initiateIdleTimer();
					// this.showform = 'password';
				}
			}, err => {
				if (err && err.error && err.error.message) {
					toastr.error(atob(err.error.message));
					if (atob(err.error.message).trim() === ERROR_RESPONSE_MESSAGE.INVALID_OTP_5_TIMES) {
						// this.showform = 'generateOTP';
					}
				}
			})
		}
	}
	get validOTP() {
		if ((!!this.otpForm.get('mobileOTP').value || !!this.otpForm.get('emailOTP').value)) {
			if (!!this.otpForm.get('mobileOTP').value) {
				return !!this.otpForm.get('mobileOTP').valid;
			} else {
				return !!this.otpForm.get('emailOTP').valid;
			}
		}
	}

	get validContactDetail() {
		if ((!!this.contactDetailForm.get('phone').value || !!this.contactDetailForm.get('email').value)) {
			if (!!this.contactDetailForm.get('phone').value) {
				return !!this.contactDetailForm.get('phone').valid;
			} else {
				return !!this.contactDetailForm.get('email').valid;
			}
		}
	}

	updateContactDetails() {
		const setContactDetails = {
			phone: this.contactDetailForm.get('phone').value,
			email: this.contactDetailForm.get('email').value,
			userName: this.userCredentials.userName,
		};

		this.registrationService.updateUserContactInfo(setContactDetails).subscribe(res => {
			if (res) {
				this.userContactDetails = res;
				this.contactDetailForm.reset();
				this.verifyUpdateDetails = true;
				// this.showform = 'password';
			}
		}, err => {
			if (err && err.error && err.error.message) {
				console.log("err message : ", err.error.message)
				// toastr.error(err.error.message);
				// return
				// if (atob(err.error.message).trim() === ERROR_RESPONSE_MESSAGE.INVALID_OTP_5_TIMES) {
				// 	// this.showform = 'generateOTP';
				// }
			}
		})
	}
	resetModel() {
		this.contactDetailForm.reset();
		this.verifyUpdateDetails = false;
		this.otpForm.reset();
		Helpers.closeModal('otpVerificationFirstTime');
		Helpers.closeModal('otpVerification');
		this.otpForm.controls.emailOTP.clearValidators();
		this.otpForm.controls.mobileOTP.clearValidators();
		this.otpForm.controls.emailOTP.updateValueAndValidity();
		this.otpForm.controls.mobileOTP.updateValueAndValidity();
	}
	spocChange() {
		this.isNoContinueLoginFlag = false;
		Helpers.closeModal('spoc-confirmation')
		this.sharedService.setData('spoc-change');
		this.storageService.setObject('access_token', this.token);
		this.routingService.goNext();
		return;
	}

	ContinueForOtpVerification() {
		this.isNoContinueLoginFlag = true;
		Helpers.closeModal('spoc-confirmation');
		this.generateOTPs();
		this.otpForm.controls.emailOTP.clearValidators();
		this.otpForm.controls.mobileOTP.clearValidators();
		this.otpForm.controls.emailOTP.updateValueAndValidity();
		this.otpForm.controls.mobileOTP.updateValueAndValidity();
		this.verifyUpdateDetails = true;
		Helpers.openModal('otpVerificationFirstTime');
	}

	continueDashboard() {
		Helpers.closeModal('spoc-confirmation');
		Helpers.closeModal('otpVerificationFirstTime');
		this.loginService.updateSpocFlag().subscribe(res => { });
		this.storageService.setObject('access_token', this.token);
		this.routingService.goNext();
	}

	generateOTPForLoginVerification() {
		const userDetails = this.jwtHelper.decodeToken(this.token);
		let payload = {
			userName: userDetails.userName,
			userType: 'PMV'
		}
		this.registrationService.generateOTPForLoginVerification(payload, userDetails.role).subscribe(res => {
			console.log(res);
			if (res) {
				toastr.success('OTP sent to on your registered mobile number!!');
				Helpers.openModal('login-otp-model');
				this.timeRemaining = 30;
				this.startTimer();
				this.isModelOpened = true;
			}
		})
	}
	reGenerateOTPForLoginVerification() {
		const userDetails = this.jwtHelper.decodeToken(this.token);
		let payload = {
			userName: userDetails.userName,
			userType: 'PMV'
		}
		this.registrationService.generateOTPForLoginVerification(payload, userDetails.role).subscribe(res => {
			console.log(res);
			if (res) {
				toastr.success('OTP sent to on your registered mobile number!!');
				this.isModelOpened = true;
				this.timeRemaining = 30;
				this.startTimer();
			}
		})
	}
	ngOnDestroy() {
		Helpers.closeModal('m_modal_1_2');
		Helpers.closeModal('login-otp-model');

		if (this.timerSubscription) {
			this.timerSubscription.unsubscribe();
		}
	}
	private startTimer() {
		this.timerSubscription = interval(1000).subscribe(() => {
			if (this.timeRemaining > 0) {
				this.timeRemaining--;
			} else {
				this.timerSubscription.unsubscribe();
				// alert('OTP has expired!');
			}
		});
	}


	// verifyLoginOTP() {
	// 	if (this.verifyOTPForm.invalid) {
	// 		toastr.error('Please fill the otp');
	// 		return
	// 	}
	// 	const userDetails = this.jwtHelper.decodeToken(this.token);
	// 	let otpDetails = {
	// 		emailOtp: this.verifyOTPForm.get('mobileOTP').value ? this.verifyOTPForm.get('mobileOTP').value : "0",
	// 		userID: this.userDetails.userName,
	// 	};
	// 	this.registrationService.verifyOTP(otpDetails).subscribe(res => {
	// 		if (window.atob(res && res.message) == 'valid OTP') {
	// 			toastr.success('OTP verified successfully!!');
	// 			this.closeOTPModel();
	// 			this.utlityService.addUpdateBankDetails(this.mapPayLoad()).subscribe(res => {
	// 				swal('Bank Details Successfully Added', '', 'success');
	// 				this.getBankDetails();
	// 			})
	// 			this.closeModal();
	// 		} else {
	// 			toastr.warn(window.atob(res && res.message));
	// 		}
	// 	})
	// }
	verifyLoginOTP() {
		if (this.verifyOTPForm.invalid) {
			toastr.error('Please fill the otp');
			return
		}
		const userDetails = this.jwtHelper.decodeToken(this.token);

		if (this.verifyOTPForm.valid) {
			const otpDetails = {
				phoneOtp: this.verifyOTPForm.get('mobileOTP').value,
				userName: userDetails.userName
			};
			const userData = {
				// role: "Training Centre",
				// spoc: {
				// 	mobileNumber: Number(this.value.spoc.mobileNumber),
				// 	email: this.value.spoc.email,
				// 	firstName: this.value.spoc.firstName,
				// }
			}
			this.registrationService.verifyOTPForLoginVerification(otpDetails)
				.subscribe(res => {
					if (res && res.msg == 'Valid OTP') {
						swal('Verified Successfully', '', 'success');
						Helpers.closeModal('login-otp-model');
						this.sharedService.setData(null)
						this.storageService.setObject('access_token', this.token);
						this.routingService.goNext();
						this.initiateIdleTimer();
					} else if (res && res.msg == 'Invalid OTP') {
						toastr.err("Please enter valid otp");
					}
				});
			// swal('Verified Successfully', '', 'success');
			// Helpers.closeModal('login-otp-model');
			// this.sharedService.setData(null)
			// this.storageService.setObject('access_token', this.token);
			// this.routingService.goNext();
			// this.initiateIdleTimer()
			// this.submitTrainingCenter();
		} else {
			toastr.err("Please enter otp");
		}
	}


	closeOTPModel() {
		this.verifyOTPForm.get('mobileOTP').reset();
		Helpers.closeModal('login-otp-model');
		this.isModelOpened = false;
	}
	


}
